import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { TEAMS_PATH } from './constants';
import { BackButton } from './styles';

export function BackToTeams() {
  const navigate = useNavigate();

  return (
    <BackButton
      color="primary"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate(TEAMS_PATH)}
    >
      BACK
    </BackButton>
  );
}
